import { MouseEventHandler } from "react";
import photoLibrary from "../../../img/icon/photo_library.svg";
import { getFormattedNumberStr } from "../../common/Common";

interface picturesProps {
    picturesCount: number;
    onClick: MouseEventHandler<HTMLElement>;
}

const MorePictures = (props: picturesProps) => {
    return (
        <>
            <div onClick={props.onClick}>
                <img src={photoLibrary} />
                <span> 사진 {getFormattedNumberStr(props.picturesCount)}장 </span>
            </div>
        </>
    );
};

export default MorePictures;
